import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function servicesView(value) {
  if (!Array.isArray(value)) {
    return { status: NOT_CONFIGURED, services: [] };
  }
  return {
    status: null,
    services: value.map((item, index) => ({
      index,
      serviceId: activationValueText(readField(item, "service_id")),
      state: activationValueText(readField(item, "state")),
    })),
  };
}

export function roofingV2ServiceAreaView(settings) {
  const geo = settings && settings.geo;
  const callouts = geo && geo.regional_callouts;
  const services = servicesView(settings && settings.services);
  const calloutsAllowed = readField(callouts, "allowed");
  const minJobValue = readField(callouts, "min_job_value");
  const crossesStateBorders = readField(geo, "crosses_state_borders");
  return {
    servicesStatus: services.status,
    services: services.services,
    calloutsAllowed: calloutsAllowed === "" ? '""' : calloutsAllowed,
    minJobValue: minJobValue === "" ? '""' : minJobValue,
    crossesStateBorders: crossesStateBorders === "" ? '""' : crossesStateBorders,
  };
}
